/** Minimal reactive store. */
export type Listener<T> = (state: T, prev: T) => void;

export class Store<T extends object> {
  #state: T;
  #listeners = new Set<Listener<T>>();
  constructor(initial: T) {
    this.#state = initial;
  }
  get state(): T {
    return this.#state;
  }
  set(patch: Partial<T> | ((s: T) => Partial<T>)): void {
    const p = typeof patch === 'function' ? patch(this.#state) : patch;
    let changed = false;
    for (const k in p) if (p[k] !== this.#state[k]) changed = true;
    if (!changed) return;
    const prev = this.#state;
    this.#state = { ...prev, ...p };
    for (const l of this.#listeners) l(this.#state, prev);
  }
  subscribe(l: Listener<T>): () => void {
    this.#listeners.add(l);
    return () => this.#listeners.delete(l);
  }
}
